export default __webpack_public_path__ + "static/media/pencil.776b9786.svg";